import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import WhatWeBuy from '../pages/what-we-buy/page';
import HowItWorks from '../pages/how-it-works/page';
import ServiceAreas from '../pages/service-areas/page';
import NotFound from '../pages/NotFound';

// Blog Pages
import Blog from '../pages/blog/page';
import MaximizingValueSurplusEquipment from '../pages/blog/maximizing-value-surplus-equipment/page';
import RefineryTurnaroundEquipmentGuide from '../pages/blog/refinery-turnaround-equipment-guide/page';
import ControlValveSelectionGuide from '../pages/blog/control-valve-selection-guide/page';
import IndustrialInstrumentationTrends from '../pages/blog/industrial-instrumentation-trends/page';
import PressureGaugeMaintenance from '../pages/blog/pressure-gauge-maintenance/page';
import FlowMeterComparison from '../pages/blog/flow-meter-comparison/page';

// State Pages
import Texas from '../pages/states/texas/page';
import Oklahoma from '../pages/states/oklahoma/page';
import Louisiana from '../pages/states/louisiana/page';
import NewMexico from '../pages/states/new-mexico/page';
import Kansas from '../pages/states/kansas/page';
import NorthDakota from '../pages/states/north-dakota/page';
import SouthDakota from '../pages/states/south-dakota/page';
import Wyoming from '../pages/states/wyoming/page';
import Utah from '../pages/states/utah/page';

// City Pages - Using regular imports for consistency
import Houston from '../pages/cities/houston/page';
import Dallas from '../pages/cities/dallas/page';
import Beaumont from '../pages/cities/beaumont/page';
import Tulsa from '../pages/cities/tulsa/page';
import LakeCharles from '../pages/cities/lake-charles/page';
import Denver from '../pages/cities/denver/page';
import Austin from '../pages/cities/austin/page';
import SanAntonio from '../pages/cities/san-antonio/page';
import CorpusChristi from '../pages/cities/corpus-christi/page';
import ElPaso from '../pages/cities/el-paso/page';
import OklahomaCity from '../pages/cities/oklahoma-city/page';
import BatonRouge from '../pages/cities/baton-rouge/page';
import Albuquerque from '../pages/cities/albuquerque/page';
import Roswell from '../pages/cities/roswell/page';
import Hobbs from '../pages/cities/hobbs/page';
import Artesia from '../pages/cities/artesia/page';
import Carlsbad from '../pages/cities/carlsbad/page';
import Farmington from '../pages/cities/farmington/page';
import Wichita from '../pages/cities/wichita/page';
import Topeka from '../pages/cities/topeka/page';
import KansasCity from '../pages/cities/kansas-city/page';
import Bismarck from '../pages/cities/bismarck/page';
import Williston from '../pages/cities/williston/page';
import SiouxFalls from '../pages/cities/sioux-falls/page';
import RapidCity from '../pages/cities/rapid-city/page';
import Casper from '../pages/cities/casper/page';
import Cheyenne from '../pages/cities/cheyenne/page';
import SaltLakeCity from '../pages/cities/salt-lake-city/page';
import Provo from '../pages/cities/provo/page';
import WeBuySurplusValvesPage from '../pages/we-buy-surplus-valves/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/what-we-buy',
    element: <WhatWeBuy />
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />
  },
  {
    path: '/service-areas',
    element: <ServiceAreas />
  },
  // State-specific pages
  {
    path: '/texas',
    element: <Texas />
  },
  {
    path: '/oklahoma',
    element: <Oklahoma />
  },
  {
    path: '/louisiana',
    element: <Louisiana />
  },
  {
    path: '/new-mexico',
    element: <NewMexico />
  },
  {
    path: '/kansas',
    element: <Kansas />
  },
  {
    path: '/north-dakota',
    element: <NorthDakota />
  },
  {
    path: '/south-dakota',
    element: <SouthDakota />
  },
  {
    path: '/wyoming',
    element: <Wyoming />
  },
  {
    path: '/utah',
    element: <Utah />
  },
  // Texas Cities
  {
    path: '/houston',
    element: <Houston />
  },
  {
    path: '/dallas',
    element: <Dallas />
  },
  {
    path: '/beaumont',
    element: <Beaumont />
  },
  {
    path: '/austin',
    element: <Austin />
  },
  {
    path: '/san-antonio',
    element: <SanAntonio />
  },
  {
    path: '/corpus-christi',
    element: <CorpusChristi />
  },
  {
    path: '/el-paso',
    element: <ElPaso />
  },
  // Oklahoma Cities
  {
    path: '/tulsa',
    element: <Tulsa />
  },
  {
    path: '/oklahoma-city',
    element: <OklahomaCity />
  },
  // Louisiana Cities
  {
    path: '/lake-charles',
    element: <LakeCharles />
  },
  {
    path: '/baton-rouge',
    element: <BatonRouge />
  },
  // New Mexico Cities
  {
    path: '/albuquerque',
    element: <Albuquerque />
  },
  {
    path: '/roswell',
    element: <Roswell />
  },
  {
    path: '/hobbs',
    element: <Hobbs />
  },
  {
    path: '/artesia',
    element: <Artesia />
  },
  {
    path: '/carlsbad',
    element: <Carlsbad />
  },
  {
    path: '/farmington',
    element: <Farmington />
  },
  // Kansas Cities
  {
    path: '/wichita',
    element: <Wichita />
  },
  {
    path: '/topeka',
    element: <Topeka />
  },
  {
    path: '/kansas-city',
    element: <KansasCity />
  },
  // North Dakota Cities
  {
    path: '/bismarck',
    element: <Bismarck />
  },
  {
    path: '/williston',
    element: <Williston />
  },
  // South Dakota Cities
  {
    path: '/sioux-falls',
    element: <SiouxFalls />
  },
  {
    path: '/rapid-city',
    element: <RapidCity />
  },
  // Wyoming Cities
  {
    path: '/casper',
    element: <Casper />
  },
  {
    path: '/cheyenne',
    element: <Cheyenne />
  },
  // Utah Cities
  {
    path: '/salt-lake-city',
    element: <SaltLakeCity />
  },
  {
    path: '/provo',
    element: <Provo />
  },
  // Colorado (Regional Hub)
  {
    path: '/denver',
    element: <Denver />
  },
  // Blog routes
  {
    path: '/blog',
    element: <Blog />
  },
  {
    path: '/blog/maximizing-value-surplus-equipment',
    element: <MaximizingValueSurplusEquipment />
  },
  {
    path: '/blog/refinery-turnaround-equipment-guide',
    element: <RefineryTurnaroundEquipmentGuide />
  },
  {
    path: '/blog/control-valve-selection-guide',
    element: <ControlValveSelectionGuide />
  },
  {
    path: '/blog/industrial-instrumentation-trends',
    element: <IndustrialInstrumentationTrends />
  },
  {
    path: '/blog/pressure-gauge-maintenance',
    element: <PressureGaugeMaintenance />
  },
  {
    path: '/blog/flow-meter-comparison',
    element: <FlowMeterComparison />
  },
  {
    path: '/we-buy-surplus-valves',
    element: <WeBuySurplusValvesPage />
  },

  // 404 Not Found
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
